export default __webpack_public_path__ + "static/media/pdf.78b17337.svg";